module.exports = __webpack_public_path__ + "img/a3.f6402e97.jpg";